<template>
    <b-modal title="Send receipt to email" 
             centered
             @close="closeModal"
             @hide="closeModal"
             @ok="handleBtnOk"
             v-model="modalShow">
        <b-container fluid>
            <b-row>
                <b-col>
                    <b-form-input v-model.trim="$v.email.$model" 
                                  type="text"
                                  placeholder="Email">
                    </b-form-input>
                    <p v-if="!$v.email.required || !$v.email.email">Email is not valid</p>
                </b-col>
            </b-row>     
        </b-container>
    </b-modal>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators' 
import { timer } from 'vue-timers'
export default {
    inject: ['eventBus'],
    props : {
        show : {Type: Boolean}
    },
    timers : {
        log: {
            time: 10000
        }
    }, 
    data () {
        return {
            email: "",
            modalShow : false,
            orderId : ''
        }
    },
    validations: {
        email : {
            required,
            email
        }
    },
    methods : {
        openModal(orderId) {
            this.modalShow = true;
            this.orderId = orderId;
        },
        closeModal() {
            this.email = "";
            this.modalShow = false;
        },
        handleBtnOk(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.handleSubmit();

        },
        async handleSubmit() {
            if (!this.$v.email.required || !this.$v.email.email) {
                this.$snotify.error('Email is not valid!!!')
                return
            }
            this.$store.commit('loading/setLoadingState', true);
            await this.$store.dispatch('receipts/sendReceiptAction', {'orderId' : this.orderId, 'email': this.email}); 
            this.email = "";
            this.orderId = "";
            this.$store.commit('loading/setLoadingState', false);
            this.$snotify.error('The receipt is sent!!!');
        }
    },
    created() {
        this.eventBus.$on('OrderReceiptEmailModalOpenedEvent', this.openModal);
    },
    destroyed() {
        this.eventBus.$off('OrderReceiptEmailModalOpenedEvent', this.openModal);

    }

}
</script>